const LABEL_KEYS = ['unset', 'inTransit', 'readyForOperation', 'inOperation', 'temporaryInactive', 'decommissioned'];
export default {
  name: 'CoreVirtualDeviceOperationalStatus',
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    labels() {
      return LABEL_KEYS.reduce((acc, key, index) => {
        acc[index] = this.$i18n_t(`DigitalTwin.VirtualDevice.bulkUpdate.operationalStatus.${key}`);
        return acc;
      }, {});
    },
    label() {
      return this.labels[this.value];
    },
    hasCustomValue() {
      return this.value !== null && this.value !== undefined && this.value !== '';
    }
  }
};